import i18n from '../../../../../i18n';
import { FormType, NewForm, RequiredField } from '../../../../../types/apiResponse/form';
import { DateFrequency, SmartsellEnv } from '../../../../../utils/enums';
import {
  getSelectOptionsFromFormOpeningLocations,
  SelectOptionSpecValue,
} from '../../../../../utils/getSelectOptions';
import { currentDateMoreDays, getFrequencyOptions } from '../../../../../utils/helpers';

export const defaultFormData: NewForm = {
  description: '',
  type: 'GENERIC',
  executionEnvironment: null,
  pesqmkt_View: null,
  initialDate: currentDateMoreDays(1),
  finalDate: currentDateMoreDays(31),
  isRequired: false,
  frequency: getFrequencyOptions()[0].value,
  openingLocal: getSelectOptionsFromFormOpeningLocations()[0].value,
  fields: [],
  active: false,
  audienceId: null,
  audience: null,
};

export const isIsRequiredInputDisabled = (formData: NewForm): boolean => {
  if (formData.type === 'NEW_CUSTOMER') return true;

  return false;
};

export const isFrequencyInputDisabled = (formData: NewForm): boolean => {
  if (formData.type === 'NEW_CUSTOMER') return true;

  return false;
};

export const isOpeningLocalInputDisabled = (formData: NewForm): boolean => {
  if (formData.type === 'NEW_CUSTOMER') return true;

  return false;
};

export const handleFormTypeChange = (
  selectedOption: SelectOptionSpecValue<FormType>,
  formData: NewForm,
): NewForm => {
  const data = { ...formData };

  data.type = selectedOption.value;

  if (selectedOption.value === 'NEW_CUSTOMER') {
    data.isRequired = false;
    data.frequency = DateFrequency.always;
    data.openingLocal = SmartsellEnv.newCustomerButton;
  }

  return data;
};

export const getRequiredFormFields = (formData: NewForm) => {
  let requiredFields: RequiredField[] = [];

  if (formData.type === 'NEW_CUSTOMER') {
    requiredFields = [
      { label: i18n.t('tabPrice'), value: 'tab_price', target: 'type' },
      { label: i18n.t('paymentCondition'), value: 'payment_condition', target: 'type' },
      { label: i18n.t('paymentMethod'), value: 'payment_method', target: 'type' },
      { label: i18n.t('billingUnit'), value: 'billing_unit', target: 'type' },
      { label: i18n.t('companyName'), value: 'company_name', target: 'type' },
      { label: i18n.t('tradeName'), value: 'trade_name', target: 'type' },
      { label: i18n.t('cgcCpf'), value: 'cgc_cpf', target: 'type' },
      { label: i18n.t('fullAddress'), value: 'full_address', target: 'type' },
    ];
  }

  return requiredFields;
};

export const getRequiredFormFieldsNotInForm = (formData: NewForm) => {
  const requiredFields = getRequiredFormFields(formData);

  return requiredFields.filter(
    (field) =>
      !formData.fields.find((f) => {
        if (field.target === 'description') {
          return f.description === field.value;
        } else if (field.target === 'type') {
          return f.type === field.value;
        } else {
          return false;
        }
      }),
  );
};

export const openingLocationsToBeHidden = (formData: NewForm) => {
  if (formData.type === 'GENERIC') {
    return getSelectOptionsFromFormOpeningLocations().filter(
      (option) => option.value != SmartsellEnv.newCustomerButton,
    );
  }

  return getSelectOptionsFromFormOpeningLocations();
};
